import Checkbox from '@/common/components/Checkbox';
import TextField from '@/common/components/TextField';
import { ProductsConsumptionInCurrentPeriodLimitsData } from '@/common/types/productsConsumptionInCurrentPeriodLimits.type';
import { formatCurrency, formatDecimal, formatUnit } from '@/common/utils/formatters';
import { FileBoxIcon } from 'lucide-react';
import { options as applicableProductsPeriodLimit } from "../../../constants/applicableProductsPeriodLimit.constant";
import { CardProductLimit } from '../../../types/equipments.type';
import Skeleton from '@/common/components/Skeleton';

interface ApplicableProductProps {
  applicableProduct: CardProductLimit;
  limitByTransaction?: boolean;
  limitByPeriod?: boolean;
  index: number;
  productConsumptionInCurrentPeriodLimits?: ProductsConsumptionInCurrentPeriodLimitsData[string]
  productsConsumptionInCurrentPeriodLimitsIsPending: boolean
}

export const ApplicableProduct = ({
  applicableProduct,
  limitByTransaction,
  limitByPeriod,
  index,
  productConsumptionInCurrentPeriodLimits,
  productsConsumptionInCurrentPeriodLimitsIsPending,
}: ApplicableProductProps) => {
  return (
    <div className="flex w-full flex-col gap-y-6 bg-[#FFFFFF0D] rounded-sm p-4">
      <div className="flex items-center">
        <div className="flex items-center gap-x-2 bg-white-200 p-2">
          <FileBoxIcon strokeWidth={1} />

          <p>
            {applicableProduct.product.display_name}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-x-6">
        <Checkbox
          label="Limite por transação"
          name={`card_product_limits_attributes.${index}.limitByTransaction`}
          labelClassName="text-[10px] italic font-light"
          checked={limitByTransaction}
          disabled
        />

        <Checkbox
          label="Limite por período"
          name={`card_product_limits_attributes.${index}.limitByPeriod`}
          labelClassName="text-[10px] italic font-light"
          checked={limitByPeriod}
          disabled
        />
      </div>

      {limitByTransaction && (
        <div className="flex flex-col gap-y-4">
          <p>
            Limite por Transação
          </p>

          <div className="flex w-full gap-x-2">
            <TextField
              name={`card_product_limits_attributes.${index}.transactionLimit.quantity`}
              label="Quantidade"
              value={applicableProduct.quantity_limit_per_transaction ? formatUnit(formatDecimal(applicableProduct.quantity_limit_per_transaction), applicableProduct?.product?.unit_for_quantity || '') : ''}
              className="w-full"
              disabled
            />

            <p className="mt-9">
              Ou
            </p>

            <TextField
              name={`card_product_limits_attributes.${index}.transactionLimit.totalValue`}
              label="Valor total"
              value={applicableProduct.credit_limit_per_transaction ? formatCurrency(parseFloat(applicableProduct.credit_limit_per_transaction)) : ''}
              className="w-full"
              disabled
            />
          </div>

          <p className="font-light text-xs italic mt-[-8px]">
            Quando não determinado um limite, o motorista irá visualizar o valor de <span className="font-bold not-italic">10.000</span>, para evitar fraude.
          </p>
        </div>
      )}

      {limitByPeriod && (
        <div className="flex flex-col gap-y-4">
          <p>
            Limite por Período
          </p>

          <TextField
            name={`card_product_limits_attributes.${index}.periodLimit.period`}
            label="Período"
            value={applicableProduct.period_in_days ? applicableProductsPeriodLimit.find((option) => option.value === `${applicableProduct.period_in_days}`)?.label || '' : ''}
            disabled
          />

          <div className="flex w-full gap-x-2">
            <div className="flex w-full flex-col gap-y-1">
              <TextField
                name={`card_product_limits_attributes.${index}.periodLimit.quantity`}
                label="Quantidade"
                value={applicableProduct.quantity_limit_per_period ? formatUnit(formatDecimal(applicableProduct.quantity_limit_per_period) || '', applicableProduct?.product?.unit_for_quantity || '') : ''}
                className="w-full"
                disabled
              />

              {applicableProduct.quantity_limit_per_period ? (
                !productsConsumptionInCurrentPeriodLimitsIsPending ? (
                  <p className="italic text-xs text-white-400">
                    Quantidade utilizada:{' '}
                    {formatUnit(
                      formatDecimal(productConsumptionInCurrentPeriodLimits?.quantity_total || 0),
                      applicableProduct.product?.unit_for_quantity || '',
                    )}
                  </p>
                ) : (
                  <Skeleton className="w-32 h-4" />
                )
              ) : null}
            </div>

            <p className="mt-9">
              Ou
            </p>

            <div className="flex w-full flex-col gap-y-1">
              <TextField
                name={`card_product_limits_attributes.${index}.periodLimit.totalValue`}
                label="Valor total"
                value={applicableProduct.credit_limit_per_period ? formatCurrency(parseFloat(applicableProduct.credit_limit_per_period)) : ''}
                className="w-full"
                disabled
              />

              {applicableProduct.credit_limit_per_period ? (
                !productsConsumptionInCurrentPeriodLimitsIsPending ? (
                  <p className="italic text-xs text-white-400">
                    Valor utilizado:{' '}
                    {formatCurrency(parseFloat(productConsumptionInCurrentPeriodLimits?.consumed_total || '0'))}
                  </p>
                ) : (
                  <Skeleton className="w-32 h-4" />
                )
              ) : null}
            </div>
          </div>

          <p className="font-light text-xs italic mt-[-8px]">
            Quando não determinado um limite, o motorista irá visualizar o valor de <span className="font-bold not-italic">10.000</span>, para evitar fraude.
          </p>
        </div>
      )}
    </div>
  );
};
